import axios from 'axios';
import create from 'zustand';
import { ADMINAPI_BASE_URL } from "utils/base_urls"

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';

const RequestProjectData = async (keyworkd) => {
  try {
    const response = await axios.request({
      baseURL: ADMINAPI_BASE_URL,
      url: `/project/api/list`
    });

    if (response.status === 200) {
      return response
    };
  } catch (error) {
    console.log(error);
  }
}

const RequestReverseGeocoding = async (longitude, latitude) => {
  try {
    const response = await axios.request({
      baseURL: 'https://api.mapbox.com/geocoding/v5/mapbox.places',
      url: `/${longitude},${latitude}.json?access_token=pk.eyJ1IjoiZmFzdG1hcCIsImEiOiJja2N4Y3FodWswNmVzMnJudnRwZW8yY3huIn0.vRWDQDzqfwaEFquoc5SF3g`
    });

    if (response.status === 200) {
      return response
    };
  } catch (error) {
    console.log(error);
  }
}

const RequestSearchData = async (keyworkd) => {
  try {
    const response = await axios.request({
      baseURL: 'https://api.mapbox.com/geocoding/v5/mapbox.places',
      url: `/${keyworkd}.json?access_token=pk.eyJ1IjoiZmFzdG1hcCIsImEiOiJja2N4Y3FodWswNmVzMnJudnRwZW8yY3huIn0.vRWDQDzqfwaEFquoc5SF3g`
    });

    if (response.status === 200) {
      return response
    };
  } catch (error) {
    console.log(error);
  }
}

const RequestWeatherData = async (position) => {
  try {
    const response = await axios.request({
      baseURL: 'https://dataservice.accuweather.com/locations/v1/cities/geoposition',
      url: `/search?apikey=hYrGRV3AGNYjqOu2WGqZwA5Gh9ZE2AHd&q=${position}&details=false`
    });

    if (response.status === 200) {

      let location_key = response.data.Key;
      const weatherAPI = await axios.request({
        baseURL: 'https://dataservice.accuweather.com/currentconditions',
        url: `/v1/${parseInt(location_key)}?apikey=hYrGRV3AGNYjqOu2WGqZwA5Gh9ZE2AHd&q=${position}&details=false`
      });

      let TemperatureObj = weatherAPI.data[0].Temperature.Metric;
      TemperatureObj.Value = parseInt(TemperatureObj.Value);
      return TemperatureObj;
    };
  } catch (error) {
    console.log(error);
  }
}

const useStore = create((set, get) => ({
  showmapModal: true,
  setshowmapModal: (visibility) => set({ showmapModal: visibility }),
  mapboxvisibility: 0,
  setmapboxvisibility: (visibility) => set({ mapboxvisibility: visibility }),
  viewer: undefined,
  mapbox: undefined,
  mapboxSyncing: false,
  Current_Temperature: '--',
  currentBBOX: undefined,
  setcurrentBBOX: (BBOX) => set({ currentBBOX: BBOX }),
  setCurrent_Temperature: (temperature) => set({ Current_Temperature: temperature }),
  setmapboxSyncing: (bool) => set({ mapboxSyncing: bool }),
  cesiumSyncing: true,
  setcesiumSyncing: (bool) => set({ cesiumSyncing: bool }),
  setMapbox: (mapboxval) => set({ mapbox: mapboxval }),
  BBox: undefined,
  setBBox: (BBOX) => set({ BBox: BBOX }),
  search_result_visibility: false,
  setsearch_result_visibility: (bool) => set({ search_result_visibility: bool }),
  projectdata: async (keyworkd) => {
    try {
      return RequestProjectData(keyworkd);
    } catch (error) {
      console.log(error);
    }
  },
  SearchBarData: async (keyworkd) => {
    try {
      return RequestSearchData(keyworkd);
    } catch (error) {
      console.log(error);
    }
  },
  SearchWeatherData: async (position) => {
    try {
      return RequestWeatherData(position);
    } catch (error) {
      console.log(error);
    }
  },
  RequestReverseGeocoding: async (longitude, latitude) => {
    try {
      return RequestReverseGeocoding(longitude, latitude);
    } catch (error) {
      console.log(error);
    }
  },
  
  setViewer: (viewerval) => set({ viewer: viewerval }),
}));

export default useStore;